import {Component, OnDestroy, OnInit, QueryList, ViewChildren} from '@angular/core';
import {Store} from '@ngrx/store';
import {ActivatedRoute} from '@angular/router';
import {NavigationService} from '../../../../../../../shared/services/navigation/navigation.service';
import {
  FormularzUszkodzenService
} from '../../../../../../../shared/components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/rodzaj-elementu/uszkodzenia/formularz-uszkodzen.service';
import {SlownikService} from '../../../../../../../shared/services/slownik/slownik.service';
import {LokalizacjaUszkodzenia} from '../../../../../../../shared/model/uszkodzenia/lokalizacja-uszkodzenia';
import {SlownikUszkodzen} from '../../../../../../../shared/model/uszkodzenia/slownik-uszkodzen';
import {
  BaseLokalizacjaUszkodzenZParametryPrzedmiotyComponent
} from '../base-lokalizacja-uszkodzen-z-parametry-przedmioty.component';
import {
  ParametryUszkodzen,
  ParametryZbioruUszkodzen
} from '../../../../../../../shared/store/zbior-uszkodzen/zbiorUszkodzen';
import {
  UszkodzeniaWLokalizacjiComponent
} from '../../../../../../../shared/components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/rodzaj-elementu/uszkodzenia/lokalizacja/uszkodzenia-w-lokalizacji.component';

@Component({
  selector: 'app-runny-rury',
  templateUrl: './rynnyRury.component.html'
})

export class RynnyRuryComponent extends BaseLokalizacjaUszkodzenZParametryPrzedmiotyComponent implements OnInit, OnDestroy {

  @ViewChildren(UszkodzeniaWLokalizacjiComponent) uszkodzenia!: QueryList<UszkodzeniaWLokalizacjiComponent>;

  constructor(route: ActivatedRoute, store: Store, navigation: NavigationService,
              formularzUszkodzenService: FormularzUszkodzenService,
              slownikService: SlownikService) {
    super(route, store, navigation, formularzUszkodzenService, slownikService);
  }

  get slownikUszkodzen(): SlownikUszkodzen[] {
    return [SlownikUszkodzen.RYNNY_Z_HAKAMI_LACZNIKAMI, SlownikUszkodzen.RURY_Z_HAKAMI_LACZNIKAMI];
  }

  get lokalizacjaUszkodzen(): LokalizacjaUszkodzenia {
    return LokalizacjaUszkodzenia.RYNNY_RURY;
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  zapiszUszkodzeniazPodformularzy(): void {
    const parametry = {} as ParametryZbioruUszkodzen;
    if (this.czyDataRemontuWymagana) {
      parametry.dataRemontu = this.formularzLokalizacjiUszkodzenia.controls.dataRemontu.value;
    }
    const uszkodzenia = this.uszkodzenia
      .filter((element) => element.wszystkieWartosciWypelnione())
      .map((element) => {
        const parametryUszkodzenia = {} as ParametryUszkodzen
        return element.utworzObiektUszkodzenia(parametryUszkodzenia)
      });
    this.utworzLubAktualizujZbiorUszkodzen(parametry, uszkodzenia);
    this.zapiszLiczbePieter(this.formularzLokalizacjiUszkodzenia.controls.liczbaPieter.value);
  }
}
